import * as SystemLog from "/src/machine/ui/SystemLog";

export const IntegratedConsole = {
    log: function log(message: string, ...params: any[]) {
        SystemLog.addSysMessage({ type: 'info', message, params });
        // console.log.apply(console, ['IC: ' + message, ...params]);
    }
}
